import { Button, Typography, Form, Input, Switch } from "antd";
import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { AuthContext } from "../../context/AuthContext";
import apiPath from "../../constants/apiPath";
import encryptDecrypt from "../../helper/encryptDecrypt";
import { Constant } from "../../constants/conts";
import logo from "../../assets/images/logo-small.png";
import AuthModals from "./AuthModals";
const { Title, Paragraph } = Typography;

const SignIn = () => {

  const { request } = useRequest()
  const { setIsLoggedIn, setUserProfile } = useContext(AuthContext)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [rememberMe, setRememberMe] = useState(false);
  const [emailForReset, setEmailForReset] = useState("");

  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
  const [otpOpen, setOtpOpen] = useState(false);
  const [resetOpen, setResetOpen] = useState(false);

  const handleRememberMeChange = (checked) => {
    setRememberMe(checked);
  };

  const onFinish = (values) => {
    onSubmit(values)
  };

  const onSubmit = (values) => {
    const { email, password } = values

    if (!email) return ShowToast('Please enter email to sign in', Severty.ERROR)

    const payload = { password }

    setLoading(true)
    payload.email = email
    request({
      url: apiPath.login,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false)
        if (data.status) {
          setIsLoggedIn(true)
          if (rememberMe) {
            var emailEncrypt = encryptDecrypt.encryptEmail(values.email);
            var passwordEncrypt = encryptDecrypt.encryptPassword(values.password);

            localStorage.setItem('rememberMe', 'true');
            localStorage.setItem('ykmCe2AYEFTHobn', emailEncrypt);
            localStorage.setItem('ouUsippetc8S4Ry', passwordEncrypt);
          } else {
            localStorage.removeItem('ykmCe2AYEFTHobn');
            localStorage.removeItem('ouUsippetc8S4Ry');
          }

          localStorage.setItem('token', data.data.token)
          localStorage.setItem('platform', Constant.PROJECT_NAME)
          localStorage.setItem('userProfile', JSON.stringify(data.data.user))

          ShowToast(data.message, Severty.SUCCESS)
          setUserProfile(data.data.user)
          setTimeout(() => navigate('/dashboard'), 200)
        } else {
          ShowToast(data.message, Severty.ERROR)
        }
      },
      onError: (error) => {
        setLoading(false)
        ShowToast(error?.response?.data?.message, Severty.ERROR)
      },
    })
  }

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {

    const savedEmail = localStorage.getItem('ykmCe2AYEFTHobn');
    const savedPassword = localStorage.getItem('ouUsippetc8S4Ry');

    if (savedEmail && savedPassword) {

      var originalEmail = encryptDecrypt.decryptEmail(savedEmail);
      var originalPassword = encryptDecrypt.decryptEmail(savedPassword);

      form.setFieldsValue({ email: originalEmail, password: originalPassword });
      setRememberMe(true);
    } else {
      setRememberMe(false);
    }

  }, []);

  return (

    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 sm:p-10">
        <div className="flex flex-col items-center mb-2">
          
          <img src={logo} alt="Logo" className="w-48 mb-3" />
          
          <Title level={3} className="text-gray-800 font-semibold text-center">
            Welcome Back
          </Title>
          
          <Paragraph className="text-center text-black-500">
            Sign in to your account using your email and password
          </Paragraph>
        </div>

        <Form
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
          className="space-y-5"
        >
          <Form.Item
            label={<span className="text-gray-700 font-medium">Email Address</span>}
            name="email"
            rules={[
              { type: "email", message: "Please enter a valid email address!" },
              { max: 255, message: "Email address cannot exceed 255 characters!" },
              { required: true, message: "Please enter your email!" },
            ]}
          >
            <Input
              className="rounded-lg border-gray-300 focus:border-[#94C13E] focus:ring focus:ring-[#94C13E]/40"
              placeholder="Enter Email Address"
            />
          </Form.Item>

          <Form.Item
            label={<span className="text-gray-700 font-medium">Password</span>}
            name="password"
            rules={[
              { required: true, message: "Please enter your password!" },
              { max: 255, message: "Password should be less than 255 characters!" },
            ]}
          >
            <Input.Password
              placeholder="Enter Password"
              className="rounded-lg border-gray-300 focus:border-[#94C13E] focus:ring focus:ring-[#94C13E]/40"
              autoComplete="off"
              onCopy={(e) => e.preventDefault()}
              onPaste={(e) => e.preventDefault()}
              onCut={(e) => e.preventDefault()}
            />
          </Form.Item>

          <div className="mr-3 flex justify-between items-center text-sm mb-4">
            <label className="flex items-center space-x-2 cursor-pointer text-gray-600">
              <Switch
                checked={rememberMe}
                onChange={handleRememberMeChange}
                style={{
                  marginLeft: "-11px",
                  backgroundColor: rememberMe ? "#94C13E" : "#e5e7eb",
                  borderColor: rememberMe ? "#94C13E" : "#d1d5db",
                }}
              />
              <span>Remember me</span>
            </label>

            <button
              type="button"
              onClick={() => setForgotPasswordOpen(true)}
              className="text-[#055392] hover:text-[#94C13E] underline font-medium"
            >
              Forgot Password?
            </button>
          </div>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="w-full bg-[#94C13E] hover:bg-[#82b32e] text-white font-semibold py-3 rounded-lg transition duration-200"
            >
              Sign In
            </Button>
          </Form.Item>
        </Form>
      </div>

      <AuthModals
        openForgot={forgotPasswordOpen}
        setOpenForgot={setForgotPasswordOpen}
        otpOpen={otpOpen}
        openOTP={setOtpOpen}
        resetOpen={resetOpen}
        openReset={setResetOpen}
        email={emailForReset}
        setEmail={setEmailForReset}
      />
    </div>
  )
}

export default SignIn
